import CommonService from '@/services/CommonService';
import {
  RESET_ALL_TOGGLE,
  SET_MESSAGE_MODAL,
  SET_CONFIRM_MODAL,
  TOGGLE_BILL_MODAL_VISIBLE,
  TOGGLE_CREDIT_BACK_BUTTON,
  SET_ACTIVE_ELEMENT,
  TOGGLE_ORDER_LEVEL_BUTTON,
  TOGGLE_MIXER_MODAL,
  TOGGLE_MENU_SIDE,
  START_LOADING,
  END_LOADING
} from '../mutation-types';

// state
const localState = () => ({
  isBillModalVisible: false,
  isCreditBackButtonActive: false,
  isMixerModalVisible: false,
  isOrderLevelButtonActive: false,
  isMenuSideVisible: false,
  messageModal: '',
  confirmModal: null,
  activeElement: null,
  isLoading: false,
  isNumPad: true,
});

// mutations
const mutations = {
  [RESET_ALL_TOGGLE](state) {
    Object.assign(state, localState());
  },

  [SET_MESSAGE_MODAL](state, message = '') {
    state.messageModal = message;
  },

  [SET_CONFIRM_MODAL](state, confirm) {
    state.confirmModal = confirm;
  },

  [TOGGLE_BILL_MODAL_VISIBLE](state, status = null) {
    state.isBillModalVisible = (status !== null) ? status : !state.isBillModalVisible;
  },

  [TOGGLE_CREDIT_BACK_BUTTON](state, status = null) {
    state.isCreditBackButtonActive = (status !== null) ? status : !state.isCreditBackButtonActive;
  },

  [TOGGLE_ORDER_LEVEL_BUTTON](state, status = null) {
    state.isOrderLevelButtonActive = (status !== null) ? status : !state.isOrderLevelButtonActive;
  },

  [TOGGLE_MIXER_MODAL](state, status = null) {
    state.isMixerModalVisible = (status !== null) ? status : !state.isMixerModalVisible;
  },

  [TOGGLE_MENU_SIDE](state, status = null) {
    state.isMenuSideVisible = (status !== null) ? status : !state.isMenuSideVisible;
  },

  [SET_ACTIVE_ELEMENT](state, element) {
    if(state.isLoading || !element || element.tagName.toLowerCase() == 'input') return;
    if(element.tagName.toLowerCase() == 'button') {
      state.activeElement = element;
      return;
    }
    state.activeElement = CommonService.getButtonNodeParent(element);
  },

  [START_LOADING](state) {
    setTimeout(() => {
      state.isLoading = true;
      if(!state.activeElement) return;
      CommonService.addLoading(state.activeElement);
    }, 100);
  },

  [END_LOADING](state) {
    state.isLoading = false;
    if(!state.activeElement) return
    CommonService.removeLoading(state.activeElement);
    state.activeElement = null;
  }
};

export default {
  state: localState(),
  mutations,
};
